var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.44C40 37.3 37.3 40 32.44 40H7.56C2.7 40 0 37.3 0 32.44V7.56C0 2.7 2.7 0 7.56 0H32.45C37.3 0 40 2.7 40 7.56V32.44Z",
    fill: "#FFE600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7197 18.0494V14.2294L27.0997 12.8494V16.1594L28.2997 17.3594L33.1297 12.5294L34.3197 13.7194C34.3097 12.8194 34.1297 10.2094 31.9197 8.03942C29.5397 5.73942 26.9597 6.77942 26.0797 7.65942L21.2597 12.4794L22.4897 13.7094L19.9997 16.2194L17.5097 13.7294L18.7397 12.4994L13.9197 7.67942C13.0397 6.79942 10.4597 5.75942 8.07969 8.05942C5.86969 10.2294 5.68969 12.8394 5.67969 13.7394L6.86969 12.5494L11.6997 17.3794L12.8997 16.1794V12.8694L14.2797 14.2494V18.0694L16.2197 19.9994L6.65969 29.5594L10.4397 33.3294L19.9997 23.7794L29.5597 33.3394L33.3397 29.5694L23.7797 19.9994L25.7197 18.0494Z",
    fill: "#2B2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaif);
export default __webpack_public_path__ + "static/media/raif.2ce8df59e8603ab8103d2e94c21b535e.svg";
export { ForwardRef as ReactComponent };